export default __webpack_public_path__ + "static/media/Mark-5-Blueprints-02.d4617797.jpg";